import { StoreAction, XmAction } from 'store/actions';
import { NowLineLock } from './models/line-lock';
import { NowLineLockAuthCheck } from './models/line-lock-auth';

export function nowLineLockReducer(state: NowLineLock, action: XmAction<NowLineLock>): NowLineLock {
    switch (action.type) {
        case StoreAction.POST_LINE_LOCK:
            return action.payload;
        default:
            return state;
    }
}

export function nowLineLockAuthCheckReducer(state: NowLineLockAuthCheck, action: XmAction<NowLineLockAuthCheck>): NowLineLockAuthCheck {
    switch (action.type) {
        case StoreAction.GET_NOW_LINE_LOCK_AUTH_CHECK:
            return action.payload;
        default:
            return state;
    }
}
